import { render } from "./VoucherReplenishmentStatus.vue?vue&type=template&id=5cfa7463&scoped=true"
import script from "./VoucherReplenishmentStatus.vue?vue&type=script&lang=js"
export * from "./VoucherReplenishmentStatus.vue?vue&type=script&lang=js"

import "./VoucherReplenishmentStatus.vue?vue&type=style&index=0&id=5cfa7463&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfa7463"]])

export default __exports__